module.exports = __webpack_public_path__ + "static/media/icon-sheet.3dfb71b4.png";